import { Component } from 'react';
import styled, { css } from 'styled-components';
import { path, fontSize } from '../../../../../common/css/setting/variable';

interface IProps {
  titleText: string;
  hasPayPay: boolean;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Main = styled.h2`
  font-weight: bold;
`;

const Point = styled.p`
  display: flex;
  align-items: center;
  margin-left: 16px;
`;

const PointIconStyle = css`
  position: relative;
  display: block;
  height: 20px;
  margin-right: 2px;
  background-repeat: no-repeat;
`;

const PayPayIcon = styled.span`
  ${PointIconStyle}
  padding-left: 22px;
  font-size: ${fontSize.px12};
  font-weight: bold;
  line-height: 20px;
  background-image: url(${path.img_icon_PayPay});
  background-size: 20px auto;
`;

const Text = styled.span`
  align-self: flex-end;
  font-size: ${fontSize.px12};
  font-weight: normal;
  line-height: 20px;
`;

export default class ModuleTitleMain extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <Wrapper>
        <Main>{this.props.titleText}</Main>
        {this.props.hasPayPay ? (
          <Point>
            <PayPayIcon>PayPay残高</PayPayIcon>
            <Text>使えます</Text>
          </Point>
        ) : null}
      </Wrapper>
    );
  }
}
